import { createActionGroup, props } from '@ngrx/store';
import { FeatureType } from '../types';

export const FeatureActions = createActionGroup({
  source: 'Features',
  events: {
    'Features Updated': props<{ features: FeatureType }>(),
  },
});
